module.exports = __webpack_public_path__ + "static/media/crystal-bg.54900f5f.mp4";